var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sendlist",class:_vm.sendlist.length > 3 ? '' : 'ht',attrs:{"id":""}},[_c('DtolList',{attrs:{"orderId":_vm.orderId,"text":_vm.text},on:{"priceList":_vm.priceList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }